export default {
  edit_selection: 'Selectie bewerken',
};
